import { IApplicationState } from '../../types/redux';
import { getAeroPhotoTourLink } from '../newbuilding';

export const getIsAeroPhotoTourAvailable = (state: IApplicationState) => {
  const link = getAeroPhotoTourLink(state);

  return Boolean(link);
};
